import type { GetterTree } from 'vuex'
import type { RootState } from 'store'

export const getters: GetterTree<AuthState, RootState> = {
  isAuthenticated: (state: AuthState) => state.isAuthenticated,
  currentUser: (state: AuthState) => state.user,
  code: (state: AuthState) => state.code,
}
